<template>
    <ion-page>
        <standard-header title="Stacking" align="middle"/>
        <ion-content>
            <skeleton :rows="4" v-if="items === null" />
            <ion-searchbar v-else animated mode="ios" v-model="filter" />
            <pull-down-refresh :callback="refresh"/>
            <ion-list v-if="items">
                <ion-item
                    lines="none"
                    v-for="item in filteredItems"
                    :key="item.id"
                    button
                    detail
                    @click="$router.push({
                        name: 'warehouse.stack.show',
                        params: {item: item.id}
                    })"
                >
                    <ion-label class="ion-text-wrap">
                        <h2>{{ item.name }}</h2>
                        <p>{{ item.item_number }} x {{ getTotalQuantity(item) }}</p>
                    </ion-label>
                </ion-item>
            </ion-list>
        </ion-content>
    </ion-page>

</template>

<script>
import StandardHeader from "@/components/StandardHeader";
import {
    IonContent,
    IonItem,
    IonLabel,
    IonList,
    IonPage,
    IonSearchbar
} from "@ionic/vue";
import {checkmarkCircle, search, barcode, listOutline} from 'ionicons/icons';
import PullDownRefresh from "@/components/PullDownRefresh";
import _ from 'lodash';
import Skeleton from "@/components/Skeleton";
export default {
    name: "ItemList",
    inject: ['$http', '$toast', '$validationAlert', '$scanner'],
    components: {
        Skeleton,
        PullDownRefresh,
        StandardHeader,
        IonContent, IonItem, IonLabel, IonList, IonPage,
        IonSearchbar
    },
    computed: {
        filteredItems() {
            return _.filter(this.items, item => {
                let found = 0;
                found += item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
                found += item.item_number.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
                return found > 0;
            });
        },
        hasSelectedLocation() {
            return this.location.id > 0;
        },
        payload() {
            const payload = {
                item: {...this.newItem},
                supplier: this.supplier
            };
            if (this.hasScannedItem) {
                payload.item = {...this.scannedItem};
            }
            payload.location = {...this.location};
            payload.quantity = this.totalQuantity;
            return payload;
        },
        hasScannedItem() {
            return !this.isNewItem && this.scannedItem.id > 0;
        }
    },
    methods: {
        ionViewDidEnter() {
            this.refresh();
        },
        refresh(event) {
            this.items = null;
            this.$http.get('/api/stack/items', {
                params: {all: true, include: 'locations,locations.pivot'}
            }).then(response => {
                this.items = response.data.items;
            }).catch(error => {
                this.$validationAlert(error);
                this.items = [];
            }).finally(() => {
                if (event && event.target.complete) {
                    event.target.complete();
                }
            });
        },
        getTotalQuantity(item) {
            return _.sum(_.map(item.locations, location => {
                return location.is_temporary?location.pivot.qty_total:0;
            }));
        }
    },
    data() {
        return {
            filter: '',
            items: null
        }
    },
    setup() {
        return {
            checkmarkCircle, search, barcode, listOutline
        }
    }

}
</script>

